import { Divider, ListItemText, Menu, MenuItem } from "@mui/material";

import type { BulkAction } from "../objectTree/utils/bulkActions";

export interface ContextMenuState {
    mouseX: number;
    mouseY: number;
    actions: BulkAction[];
}

export interface ContextMenuPopupProps {
    contextMenu: ContextMenuState | null;
    onClose: () => void;
}

export function ContextMenuPopup({ contextMenu, onClose }: ContextMenuPopupProps) {
    return (
        <Menu
            open={contextMenu !== null}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
        >
            {contextMenu?.actions.map((action) => (
                <span key={action.id}>
                    {action.dividerAbove && <Divider />}
                    <MenuItem onClick={action.onClick} disabled={action.disabled}>
                        <ListItemText>{action.label}</ListItemText>
                    </MenuItem>
                </span>
            ))}
        </Menu>
    );
}
